import { render, staticRenderFns } from "./OrganizationVehicleList.vue?vue&type=template&id=52c550df&"
import script from "./OrganizationVehicleList.vue?vue&type=script&lang=js&"
export * from "./OrganizationVehicleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports